if (!customElements.get("popular-categories")) {
  customElements.define(
    "popular-categories",
    class PopularCategories extends HTMLElement {
      constructor() {
        super();

        this.sliderEl = this.querySelector("[data-popular-categories-splide]");
        this.controlsEl = this.querySelector("[data-popular-categories-controls]");

        this.splide = null;
        this.onResizeRaf = null;

        this.initialize = this.initialize.bind(this);
        this.handleResize = this.handleResize.bind(this);

        this._waitTimer = null;
        this._waitTries = 0;
      }

      connectedCallback() {
        this.initialize();
        window.addEventListener("resize", this.handleResize, { passive: true });

        // Shopify editor safety
        document.addEventListener("shopify:section:load", (e) => {
          if (this.contains(e.target)) this.initialize();
        });
        document.addEventListener("shopify:section:unload", (e) => {
          if (this.contains(e.target)) this.destroySlider();
        });
      }

      disconnectedCallback() {
        window.removeEventListener("resize", this.handleResize);
        this.clearWait();
        this.destroySlider();
      }

      handleResize() {
        if (this.onResizeRaf) return;
        this.onResizeRaf = requestAnimationFrame(() => {
          this.onResizeRaf = null;
          this.initialize();
        });
      }

      initialize() {
        if (!this.sliderEl) return;

        // ONLY mobile slider
        const shouldHaveSlider = window.innerWidth <= 1023;

        if (shouldHaveSlider) {
          if (!this.splide) this.waitForSplideAndMount();
        } else {
          this.destroySlider();
        }
      }

      waitForSplideAndMount() {
        if (window.Splide) {
          this.clearWait();
          this.initSlider();
          return;
        }

        // wait up to ~4s
        if (this._waitTries >= 80) return;

        this._waitTries += 1;
        this._waitTimer = setTimeout(() => this.waitForSplideAndMount(), 50);
      }

      clearWait() {
        if (this._waitTimer) clearTimeout(this._waitTimer);
        this._waitTimer = null;
        this._waitTries = 0;
      }

      initSlider() {
        if (!window.Splide || this.splide) return;

        this.splide = new Splide(this.sliderEl, {
          type: "slide",
          autoWidth: true,
          perMove: 1,
          gap: "37px",
          drag: true,
          arrows: true,
          pagination: true, 
          padding: { right: "56px", left: "0px" }
        });

        this.splide.mount();

        if (this.controlsEl) this.controlsEl.style.display = "";
      }

      destroySlider() {
        this.clearWait();

        if (!this.splide) return;
        this.splide.destroy(true);
        this.splide = null;
      }
    }
  );
}